'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class;

var _components2 = require('components');

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _info = require('redux/modules/info');

var _docs = require('redux/modules/docs');

var _AgamaText = require('../../helpers/AgamaText');

var _utils = require('../../../api/actions/Db/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Playlists: {
    displayName: 'Playlists'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/Devel/web/productionRc/Agama2016/src/containers/Playlists/Playlists.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import Helmet from 'react-helmet';

// import { isSongsLoaded, loadSongs, isDocumentLoaded, loadDocument } from 'redux/modules/docs';


var Playlists = _wrapComponent('Playlists')((_dec = (0, _reactRedux.connect)(function (state) {
  return { docs: state.docs, info: state.info.data };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({ setUiProps: _info.setUiProps, changeSongText: _docs.changeSongText, changeSongProp: _docs.changeSongProp, changeSongTextPersistent: _docs.changeSongTextPersistent, panelVisibleToSide: _info.panelVisibleToSide }, dispatch);
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Playlists, _Component);

  function Playlists() {
    (0, _classCallCheck3.default)(this, Playlists);
    return (0, _possibleConstructorReturn3.default)(this, (Playlists.__proto__ || (0, _getPrototypeOf2.default)(Playlists)).apply(this, arguments));
  }

  (0, _createClass3.default)(Playlists, [{
    key: 'render',
    value: function render() {
      return _react3.default.createElement(
        'div',
        { className: 'container' },
        _react3.default.createElement(_components2.PublicPlaylistsList, null)
      );
    }
  }]);
  return Playlists;
}(_react2.Component)) || _class));

exports.default = Playlists;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Playlists/Playlists.js
// module id = 1213
// module chunks = 0